interface StateType {
    kv: string;
    tab1: string;
    tab2: string;
    tab3: string;
    exchangeBgc: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        kv: '',
        tab1: '',
        tab2: '',
        tab3: '',
        exchangeBgc: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
